import * as dd from 'dingtalk-jsapi'
import getCorpId from '@/utils/getCorpId'
// let currentAgentId
let accessToken
let userInfo = {
  id: '',
  name: ''
}

export const registerGlobalDD = function () {
  window.$dd = dd
}

export const getAccessToken = function () {
  return accessToken
}

export const getUserInfo = function () {
  return userInfo
}

export const ddInit = function (tenantId) {
  return new Promise((resolve, reject) => {
    if (window.$dd.other) {
      resolve(true)
    } else {
      getCorpId().then(corpId => {
        // dd.ready参数为回调函数，在环境准备就绪时触发，jsapi的调用需要保证在该回调函数触发后调用，否则无效。
        dd.ready(function () {
          dd.runtime.permission.requestAuthCode({
            corpId,
            onSuccess: function (result) {
              console.log('cc: ', result.code)
              resolve(result.code)
            },
            onFail: function (error) {
              console.log('onFail')
              reject(error)
            }
          })
        })
      })
    }
  })
}



// WEBPACK FOOTER //
// ./src/ddUtils/init.js